import {Button, Spinner} from "react-bootstrap";

export default function SchedulerMobileCardAction({
    disabled = false,
    isLoading = false,
    label,
    onClick,
    size = "sm",
    title,
    variant = "primary",
}) {
    return (
        <Button
            className="scheduler-mobile-card-action"
            type="button"
            variant={variant}
            size={size}
            disabled={disabled || isLoading}
            title={title}
            onClick={(event) => {
                event.stopPropagation();
                onClick();
            }}
        >
            {isLoading ? (
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-label="Updating assignment"
                />
            ) : label}
        </Button>
    );
}
